export { default as InputCheckbox } from './inputCheckbox';
export { inputCheckboxType } from './inputCheckbox.types';
export { inputCheckboxFragment } from './inputCheckbox.fragment';
export { inputCheckboxStandard } from './__fixtures__/inputCheckbox';
